module.exports = __webpack_public_path__ + "img/3.52b1f52a.png";